// Без соединения Centrifugo экран, который ждёт клип или поиск моментов, перечитывает
// данные сам. Клип пишется минуты, чаще 15 с не нужно.
export const HIGHLIGHTS_POLL_INTERVAL_MS = 15_000;
